import React, { useState, useEffect, useContext } from "react";
import { parse } from "svgson";
import { Radio, Row, Col, Button, Modal, Menu } from "antd";
// import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Crop, ZoomIn, ZoomOut, CornerUpLeft } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEraser,
  faArrowsLeftRight,
  faChevronLeft,
  faTrash,
  faArrowUpFromBracket,
  faUpDownLeftRight,
  faCopy,
  faEyeDropper,
  faFill,
  faPlusMinus,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faLink,
  faDownload,
  faPenFancy,
} from "@fortawesome/free-solid-svg-icons";
import { faVacuum } from "@fortawesome/pro-solid-svg-icons";
import {
  IonButtons,
  IonButton,
  IonToolbar,
  IonTitle,
  IonContent,
  IonModal,
  IonCol,
} from "@ionic/react";
import { HexColorPicker } from "react-colorful";

// import { readFile } from "../FileStorage";
import { AppContext } from "../../App";
import { appendUTMToURL } from "../../helpers/utmTracking";
import TopBar from "./components/TopBar";
import Canvas from "./components/Canvas";
import LayerSelector from "./components/LayerSelector";
import ToolBar from "./components/ToolBar";
import ExportMenu from "./components/ExportMenu";
// import ShareLink from "./components/ShareLink";
// import ExportFile from "./components/ExportFile";
// import Close from "./components/Close";
// import Tutorial from "./components/Tutorial";
import { t } from "../../i18n";

const SvgEditor = () => {
  const { svgStore, setSvgStore } = useContext(AppContext);
  const [svg, setSvg] = useState();
  const [svgJoined, setSvgJoined] = useState();
  const [mouseMode, setMouseMode] = useState("delete"); // integer state
  const [zoomValue, setZoomValue] = useState(100); // integer state
  const [isCanvasDisabled, setIsCanvasDisabled] = useState(false); // integer state
  const [cursor, setCursor] = useState(`crosshair`);
  const [svgHistory, setSvgHistory] = useState(new Array(50));
  const [historyIndex, setHistoryIndex] = useState(0);
  const [undoActions, setUndoActions] = useState(0);
  const [redoActions, setRedoActions] = useState(0);
  const [colors, setColors] = useState();
  const [layerSelected, setLayerSelected] = useState("all");
  const [changesMade, setChangesMade] = useState(false);
  const [toolbarState, setToolbarState] = useState("default");
  const [toolSelected, setToolSelected] = useState("move");
  const [radius, setRadius] = useState(25);
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);
  const [isProModalVisible, setIsProModalVisible] = useState(false);

  useEffect(() => {
    if (svgStore.svgString) {
      parse(svgStore.svgString).then((svg) => {
        console.log("svg: ", svg);
        updateSVGSplit(svg);
        let colorLayers = [];
        svg.children.forEach((layer) => {
          colorLayers.push(layer.attributes.fill);
        });
        setColors(colorLayers);
      });
    } else {
      // readFile({
      //   path: svgStore.uri,
      //   encoding: "utf8",
      // }).then((file) => {
      //   parse(file.data).then((svg) => {
      //     updateSVGSplit(svg);
      //   });
      // });
    }
  }, [svgStore]);

  useEffect(() => {
    if (layerSelected === "all") {
      setToolbarState("default");
      setToolSelected("move");
    }
  }, [layerSelected]);

  // write a function calles joinSVG that does the opposite of splitSVG
  const updateSVGJoined = (split) => {
    var joinedPaths = Array(split.children.length).fill("");
    for (var i = 0; i < split.children.length; i++) {
      for (var j = 0; j < split.children[i].children.length; j++) {
        joinedPaths[i] += split.children[i].children[j].attributes.d;
      }
    }
    let joined = JSON.parse(JSON.stringify(split));
    for (var i = 0; i < joined.children.length; i++) {
      joined.children[i].attributes.d = joinedPaths[i];
      joined.children[i].children = [];
    }
    let colorLayers = [];
    joined.children.forEach((layer) => {
      colorLayers.push(layer.attributes.fill);
    });
    setColors(colorLayers);

    setSvgJoined(joined);
  };

  // write a function called splitSVG that takes in a svg object and returns a new svg object with each path in its own group
  const updateSVGSplit = (joined) => {
    var splitPaths = Array(joined.children.length).fill("");
    for (var i = 0; i < joined.children.length; i++) {
      splitPaths[i] = joined.children[i].attributes.d;
    }
    let split = JSON.parse(JSON.stringify(joined));
    for (var i = 0; i < joined.children.length; i++) {
      split.children[i].attributes.d = "";
      split.children[i].children = [];
      var splitPath = splitPaths[i].split(/(?=[M])/);

      for (var j = 0; j < splitPath.length; j++) {
        if (splitPath[j] != "") {
          // add a new path to the children of the group
          split.children[i].children.push({
            name: "path",
            type: "element",
            attributes: {
              d: splitPath[j],
            },
            children: [],
          });
        }
      }
    }
    let colorLayers = [];
    split.children.forEach((layer) => {
      colorLayers.push(layer.attributes.fill);
    });
    setColors(colorLayers);
    updateSvg(split);
  };

  const updateSvg = (newSvg) => {
    if (undoActions > 0) {
      setChangesMade(true);
    }
    setUndoActions(undoActions + 1);
    setRedoActions(0);
    let items = Object.assign({}, svgHistory);
    // Make a shallow copy of the item you want to mutate
    let item = JSON.parse(JSON.stringify(newSvg));
    // Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    items[historyIndex] = item;
    // Set the state to our new copy
    setHistoryIndex((historyIndex + 1) % 50);
    setSvgHistory(items);
    setSvg(newSvg);
    updateSVGJoined(newSvg);
  };

  return (
    <>
      <Row
        style={{
          outline: "1px solid #f0f0f0",
          minWidth: "500px",
          maxHeight: "calc(100vh)",
          overflow: "hidden",
        }}
      >
        <Col
          flex="40px"
          style={{
            width: "140px",
            height: "100vh",
            borderStyle: "solid",
            borderColor: "#cfcfcf",
            borderLeftWidth: "0px",
            borderRightWidth: "1px",
            borderTopWidth: "0px",
            borderBottomWidth: "0px",
          }}
        >
          <Row
            justify="center"
            style={{
              height: "43px",
              borderStyle: "solid",
              borderColor: "#cfcfcf",
              borderBottomWidth: "1px",
              borderTopWidth: "0px",
              borderLeftWidth: "0px",
              borderRightWidth: "0px",
            }}
          >
            <Col>
              <Button
                type="text"
                onClick={() => {
                  setSvgStore(undefined);
                }}
                style={{ width: "100%", marginTop: "5px" }}
              >
                <CornerUpLeft size={16} />
              </Button>
            </Col>
          </Row>
          <Col>
            <Button
              type="text"
              onClick={() => {
                setToolSelected("move");
              }}
              style={{ width: "100%", height: "40px" }}
            >
              <FontAwesomeIcon
                icon={faUpDownLeftRight}
                color={toolSelected === "move" ? "#1890ff" : ""}
                size="1x"
              />
            </Button>
          </Col>
          <Col>
            <Button
              type="text"
              onClick={() => {
                setIsProModalVisible(true);
                // setToolSelected("cut")
              }}
              style={{ width: "100%", height: "40px" }}
            >
              <FontAwesomeIcon color={"#000000"} icon={faPlusMinus} size="1x" />
            </Button>
          </Col>
          <Col>
            <Button
              type="text"
              onClick={() => {
                setIsProModalVisible(true);
                // setToolSelected("erase")
              }}
              style={{ width: "100%", height: "40px" }}
            >
              <FontAwesomeIcon color={"#000000"} icon={faEraser} size="1x" />
            </Button>
          </Col>
          <Col>
            <Button
              type="text"
              onClick={() => {
                setIsProModalVisible(true);
                // setToolSelected("vacuum")
              }}
              style={{ width: "100%", height: "40px" }}
            >
              <FontAwesomeIcon color={"#000000"} icon={faVacuum} size="1x" />
            </Button>
          </Col>
          <Col>
            <Button
              type="text"
              onClick={() => {}}
              style={{ width: "100%", height: "40px" }}
            >
              <FontAwesomeIcon
                color={"#000000"}
                onClickHandler={() => {
                  setIsProModalVisible(true);
                  // setToolSelected("fill")
                }}
                icon={faFill}
                size="1x"
              />
            </Button>
          </Col>
        </Col>
        <Col
          flex="auto"
          style={{ maxWidth: "calc(100% - 140px)", height: "100vh" }}
        >
          <Row
            style={{
              display: "flex",
              justifyContent: "space-between",
              borderStyle: "solid",
              paddingBottom: "5px",
              borderColor: "#cfcfcf",
              width: "100%",
              borderBottomWidth: "1px",
              borderTopWidth: "0px",
              borderLeftWidth: "0px",
              borderRightWidth: "0px",
            }}
          >
            <TopBar
              setSvg={setSvg}
              svgHistory={svgHistory}
              historyIndex={historyIndex}
              setHistoryIndex={setHistoryIndex}
              undoActions={undoActions}
              setUndoActions={setUndoActions}
              redoActions={redoActions}
              setRedoActions={setRedoActions}
              updateSVGJoined={updateSVGJoined}
            />

            <Col
              flex="auto"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                textAlign: "right",
                alignItems: "center",
              }}
            >
              <Button
                type="primary"
                onClick={() => {
                  setIsShareModalVisible(true);
                }}
                style={{ marginTop: "5px", marginRight: "5px" }}
              >
                <FontAwesomeIcon
                  style={{ marginRight: "10px" }}
                  icon={faArrowUpFromBracket}
                  size="1x"
                />{" "}
                {t("Export")}
              </Button>
            </Col>
            {isShareModalVisible && (
              <ExportMenu
                svgJoined={svgJoined}
                isShareModalVisible={isShareModalVisible}
                setIsShareModalVisible={setIsShareModalVisible}
              />
            )}
          </Row>
          <Col
            flex="auto"
            style={{
              backgroundColor: "#f0f0f0",
              height: "calc(100%)",
              overflowX: "scroll",
              cursor: cursor,
            }}
          >
            <div style={{ height: "100%" }}>
              <Canvas
                isCanvasDisabled={isCanvasDisabled}
                svg={svg}
                svgJoined={svgJoined}
                setSvgJoined={setSvgJoined}
                mouseMode={mouseMode}
                zoomValue={zoomValue}
                setSvg={updateSvg}
                layerSelected={layerSelected}
                toolSelected={toolSelected}
                radius={radius}
              />
            </div>
          </Col>
        </Col>
        <Col
          flex="180px"
          style={{
            height: "100vh",
            // make light grey outline
            borderStyle: "solid",
            borderColor: "#cfcfcf",
            // only make the left border visible
            borderLeftWidth: "1px",
            borderRightWidth: "0px",
            borderTopWidth: "0px",
            borderBottomWidth: "0px",
          }}
        >
          {colors && (
            <LayerSelector
              setIsProModalVisible={setIsProModalVisible}
              setLayerSelected={setLayerSelected}
              colors={colors}
              setColors={setColors}
              layerSelected={layerSelected}
              svg={svg}
              updateSvg={updateSvg}
            />
          )}
        </Col>
      </Row>

      {/* make a modal to advertise the pro version */}
      <Modal
        title={t("Unlock More Editing Features!")}
        visible={isProModalVisible}
        onOk={() => {
          setIsProModalVisible(false);
        }}
        onCancel={() => {
          setIsProModalVisible(false);
        }}
        footer={[
          <Button
            key="continue"
            onClick={() => {
              setIsProModalVisible(false);
            }}
          >
            {t("Continue with Free Version")}
          </Button>,
          <Button
            key="upgrade"
            type="primary"
            onClick={() => {
              setIsProModalVisible(false);
              window.open(appendUTMToURL("http://pro.svgtrace.com/signup", "editor-pro-modal"));
            }}
          >
            {t("Upgrade to Pro")}
          </Button>,
        ]}
      >
        <p>
          {t("Tired of wasting time on basic editing tasks? Our pro version includes powerful editing tools that are designed to streamline your workflow and save you time.")}
        </p>
      </Modal>
    </>
  );
};

export default SvgEditor;
